import React from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import CloseButton from "../components/common/CloseButton";
import Modal from "../components/modals/Modal";
import { hideGeneralModal } from "../modules/settings/slices/settings.slice";

export const GeneralModal = () => {
	const dispatch = useDispatch();
	const { visible, title, content, formattedTitle, formattedContent } =
		useSelector((state) => state.settings.generalModal);

	const { formatMessage } = useIntl();

	const titleValue = formattedTitle ? formatMessage(formattedTitle) : title;
	const contentValue = formattedContent
		? formatMessage(formattedContent)
		: content;

	const onClose = () => {
		dispatch(hideGeneralModal());
	};

	return (
		<Modal
			isOpen={visible}
			onRequestClose={onClose}
			className="generalModal"
			aria-labelledby="generalModalHeader"
			contentLabel="generalModalContent"
			ariaHideApp={false}
		>
			<header className="header" id="generalModalHeader">
				<h1 className="title">{titleValue}</h1>
			</header>
			<CloseButton onClick={onClose} />
			<div className="content" id="generalModalContent">
				<div className="richtext">
					<div dangerouslySetInnerHTML={{ __html: contentValue }} />
				</div>
			</div>
		</Modal>
	);
};
